import axios, { AxiosInstance } from 'axios';
import config from '../config';

/**
 * Base API client with common configuration and interceptors
 */
class BaseAPIClient {
  private static instance: AxiosInstance;

  public static getInstance(): AxiosInstance {
    if (!BaseAPIClient.instance) {
      BaseAPIClient.instance = axios.create({
        baseURL: config.apiBaseUrl,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Add token to requests if available
      BaseAPIClient.instance.interceptors.request.use((config) => {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      });

      // Handle token expiration
      BaseAPIClient.instance.interceptors.response.use(
        (response) => response,
        (error) => {
          // Only redirect on 401 if we're not already on the login page
          if (error.response?.status === 401 && !window.location.pathname.includes('/login')) {
            // Clear invalid token and redirect to login
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
          }
          return Promise.reject(error);
        }
      );
    }

    return BaseAPIClient.instance;
  }
}

export const apiClient = BaseAPIClient.getInstance();
export default apiClient;